import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { castingcallInitialState } from "./states";
import axios from "axios";

const initialState = castingcallInitialState;

export const fetchCastingCallAsync = createAsyncThunk(
  "castingcalls/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, castingcalls } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getCastingCalls?index=${castingcalls?.index}&limit=${castingcalls?.limit}&search=${castingcalls?.search}&activated=${castingcalls?.filters.approved}&new_castingcall=${castingcalls?.filters.new_castingcall}&reported=${castingcalls?.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        castingcalls: response.data.content,
        totalCount: response.data.totalCastingCalls
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const CastingCallSlice = createSlice({
  name: "castingcalls",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setNewCastingCall: (state, action) => {
      state.filters.new_castingcall = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.new_castingcall = true;
      state.filters.reported = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCastingCallAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCastingCallAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.castingcalls;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchCastingCallAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default CastingCallSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setNewCastingCall,
  clearFilter,
  setReported,
  setSearchText
} = CastingCallSlice.actions;
